import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import Button from '../../../../../../../../../../../../../components/global/Button';
import Angle from '../../../../../../../../../../../../../components/global/Angle';
import DismissCircleIcon from '../../../../../../../../../../../../../components/icons/DismissCircleIcon';
import { breakpointDown } from '../../../../../../../../../../../../../services/responsive/responsive';

const propTypes = {
  onDelete: PropTypes.func,
  onMoveUp: PropTypes.func,
  onMoveDown: PropTypes.func,
};

const SlideThumbnailControls = ({ onDelete, onMoveUp, onMoveDown }) => {
  const isMobile = useMediaQuery(breakpointDown('sm'));

  return (
    <div className="slide-thumbnail-controls">
      {onDelete && (
        <Button
          btnStyle="reset"
          onClick={onDelete}
          className="slide-thumbnail-control-btn delete-btn"
        >
          <DismissCircleIcon color="#fe5851" crossColor="#fff" size={20} />
        </Button>
      )}
      {onMoveUp && (
        <Button
          btnStyle="reset"
          onClick={onMoveUp}
          className="slide-thumbnail-control-btn up-btn"
        >
          <Angle direction={isMobile ? 'left' : 'up'} />
        </Button>
      )}
      {onMoveDown && (
        <Button
          btnStyle="reset"
          onClick={onMoveDown}
          className="slide-thumbnail-control-btn down-btn"
        >
          <Angle direction={isMobile ? 'right' : 'down'} />
        </Button>
      )}
    </div>
  );
};

SlideThumbnailControls.propTypes = propTypes;

export default SlideThumbnailControls;
